import { makeAutoObservable } from 'mobx';
import { CategoryStatus, FamilyCensus, MedicalCondition, MedicalConditionStatus } from './types';
import { MedicalConditionDelegate } from './medicalConditionDelegate';

interface IncomingProps {
  name: string;
  reportedConditions: MedicalCondition[] | null;
  familyCensus: FamilyCensus;
}

export class MedicalCategoryDelegate {
  private _name: string;
  private _reportedConditions: MedicalConditionDelegate[] | null;

  public get name(): string {
    return this._name;
  }

  public get reportedConditions(): MedicalConditionDelegate[] | null {
    return this._reportedConditions;
  }

  public get status(): CategoryStatus {
    if (this._reportedConditions === null) {
      return CategoryStatus.NOT_STARTED;
    }
    const someConditionsAreMissing = this._reportedConditions.some(
      (condition) => condition.status === MedicalConditionStatus.DETAILS_MISSING,
    );
    if (someConditionsAreMissing) {
      return CategoryStatus.DETAILS_MISSING;
    }
    // Either all completed or empty array.
    return CategoryStatus.COMPLETED;
  }

  public static createConditionDelegates(
    conditions: MedicalCondition[],
    familyCensus: FamilyCensus,
  ): MedicalConditionDelegate[] {
    return conditions.map(
      (condition) =>
        new MedicalConditionDelegate({
          name: condition.name,
          affectedPeople: condition.members.map((member) => ({
            id: member.id,
            name: familyCensus[member.id].name,
            answers: member.answers,
          })),
        }),
    );
  }

  constructor(props: IncomingProps) {
    this._name = props.name;
    this._reportedConditions = props.reportedConditions
      ? MedicalCategoryDelegate.createConditionDelegates(props.reportedConditions, props.familyCensus)
      : null;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
